import createReducer from 'data/shared/createReducer';
import { SHOW_SIGN_IN_MODAL, HIDE_SIGN_IN_MODAL, SHOW_EMAIL_VERIFICATION, SHOW_FIRST_SIGN_IN, SHOW_SIGN_IN, SHOW_SIGN_UP, SHOW_FORGOT_PASSWORD, SHOW_EMAIL_SENT } from '../constants/action_types';

const initialModals = {
    showEmailVerification: true,
    showFirstSignIn: false,
    showSignIn: false,
    showSignUp: false,
    showForgotPassword: false,
    showEmailSent: false,
}

const initialState = {
    ...initialModals,
    visible: false,
    targetUrl: null,
};

const showSignInModal = (state, action) => ({
    ...state,
    visible: true,
    targetUrl: action.targetUrl
});

const hideSignInModal = (state, action) => ({
    ...initialState
});

const showEmailVerification = (state, action) => ({
    ...initialState,
    visible: true,
    email : action.data,
    targetUrl: state.targetUrl
});

const showFirstSignIn = (state, action) => ({
    ...initialState,
    visible: true,
    showEmailVerification: false,
    showFirstSignIn: true,
    email : action.data
});

const showSignIn = (state, action) => ({
    ...state,
    ...initialModals,
    visible: true,
    showEmailVerification: false,
    showSignIn: true,
    email : action.data
});

const showSignUp = (state, action) => ({
    ...initialState,
    visible: true,
    showEmailVerification: false,
    showSignUp: true,
    email : action.data,
    targetUrl: state.targetUrl
});

const showForgotPassword = (state, action) => ({
    ...initialState,
    visible: true,
    showEmailVerification: false,
    showSignIn: false,
    showForgotPassword: true,
    email : action.data
});

const showEmailSent = (state, action) => ({
    ...initialState,
    visible: true,
    showEmailVerification: false,
    showEmailSent: true,
    email : action.data
});


const signInModalReducer = createReducer(initialState, {
    [SHOW_SIGN_IN_MODAL]: showSignInModal,
    [HIDE_SIGN_IN_MODAL]: hideSignInModal,
    [SHOW_EMAIL_VERIFICATION]: showEmailVerification,
    [SHOW_FIRST_SIGN_IN]: showFirstSignIn,
    [SHOW_SIGN_IN]: showSignIn,
    [SHOW_SIGN_UP]: showSignUp,
    [SHOW_FORGOT_PASSWORD]: showForgotPassword,
    [SHOW_EMAIL_SENT]: showEmailSent,
});

export default signInModalReducer;
